
import { useState } from 'react';
import { Icon } from '@iconify/react';
import { Link } from 'react-router-dom';

// lottie icon
import rocket from '../Icons/rocket.json';
import network from '../Icons/network.json';
import consult from '../Icons/mentorship.json';
import Lottie from 'react-lottie';

import '../Home.css';

import { DoublePurpleDotHeader } from '../../All/PurpleDotHeader';

const ServiceContainer = () => {
    const softwareDevServiceLottieIcon = {
        loop: true,
        autoplay: true,
        animationData: rocket,
        rendererSettings: {
          preserveAspectRatio: "xMidYMid slice"
        }
    }

    const infraServiceLottieIcon = {
        loop: true,
        autoplay: true,
        animationData: network,
        rendererSettings: {
          preserveAspectRatio: "xMidYMid slice"
        }
    }

    const consultServiceLottieIcon = {
        loop: true,
        autoplay: true,
        animationData: consult,
        rendererSettings: {
          preserveAspectRatio: "xMidYMid slice"
        }
    }

    const [hoveredEl, setHoveredEl] = useState({
        consult: false,
        dev: false, 
        integrate: false
    });

    return(
        <div className='service-container desk1:px-20 ssdesk1:px-12 z-20'>
            <div className='max-w-[1400px] flex justify-center flex-wrap mx-auto pt-[112px] relative'>
                <div className='header flex flex-col items-center w-full'>
					<DoublePurpleDotHeader title="WHAT WE DO"/>

                    <div className='header-black tab1:text-center'>
                        Our Core Specializations
                    </div>

                    <div className='paragraph-gray text-center des:max-w-[60%] mx-auto'>
                        At MXI, we don't just build software—we design systems that <b>learn, respond, and evolve</b>.
                        From concept to deployment, we deliver <b>end-to-end</b> solutions that transform how organizations operate in complex, high-stakes environments.
                    </div>
                </div>

                <div className='content mt-12 flex items-start justify-between w-full flex-wrap px-4 smob1:px-0'>
                    <Link to='../services/automation' className='service-wrapper'>
                        <div 
                            className='' 
                            onMouseEnter={()=> {
                                setHoveredEl({
                                    ...hoveredEl,
                                    consult:true
                                })
                            }}
                            onMouseLeave={()=> {
                                setHoveredEl({
                                    ...hoveredEl,
                                    consult:false
                                })
                            }}>
                                <div className='icon'>
                                    <div>
                                        <Lottie options={consultServiceLottieIcon} />
                                    </div>
                                </div>

                                <div className='title'>
                                    Automation
                                </div>

                                <div className='descr'>
                                    Practical solutions for everyday challenges
                                </div>

                                <div className='btn-wrapper'>
                                    <div className={ hoveredEl.consult ? 'onHover' : '' }>
                                        <Icon className="text-4xl text-purple-pri rotate-45" icon="ion:arrow-up" />
                                    </div>
                                </div>
                        </div>
                    </Link>
                    
                    <Link to='../services/custom-dev' className='service-wrapper'>
                        <div 
                            className=''
                            onMouseEnter={()=> {
                                setHoveredEl({
                                    ...hoveredEl,
                                    dev:true
                                })
                            }}
                            onMouseLeave={()=> {
                                setHoveredEl({
                                    ...hoveredEl,
                                    dev:false
                                })
                            }}>
                                <div className='icon'>
                                    <div>
                                        <Lottie options={softwareDevServiceLottieIcon} />
                                    </div>
                                </div>

                                <div className='title'>
                                    Software Development
                                </div>

                                <div className='descr'>
                                    Bringing your ideas to life
                                </div>

                                <div className='btn-wrapper'>
                                    <div className={ hoveredEl.dev ? 'onHover' : '' }>
                                        <Icon className="text-4xl text-purple-pri rotate-45" icon="ion:arrow-up" />
                                    </div>
                                </div>
                        </div>
                    </Link>
                    
                    <Link to='../services/network' className='service-wrapper'>
                        <div 
                            className=''
                            onMouseEnter={()=> {
                                setHoveredEl({
                                    ...hoveredEl,
                                    integrate:true
                                })
                            }}
                            onMouseLeave={()=> {
                                setHoveredEl({
                                    ...hoveredEl,
                                    integrate:false
                                })
                            }}>
                                <div className='icon'>
                                    <div>
                                        <Lottie options={infraServiceLottieIcon} />
                                    </div>
                                </div>

                                <div className='title'>
                                    Network Infrastructure
                                </div>

                                <div className='descr'>
                                    So everything runs together effortlessly.
                                </div>

                                <div className='btn-wrapper'>
                                    <div className={ hoveredEl.integrate ? 'onHover' : '' }>
                                        <Icon className="text-4xl text-purple-pri rotate-45" icon="ion:arrow-up" />
                                    </div>
                                </div>
                        </div>
                    </Link>
                </div>

                <Link className='goto-services' to='../services'>Learn More</Link>
                
            </div>
        </div>
    )
};

export default ServiceContainer;